import { PageProps } from "@/getServerSideProps/getServerSideProps";
import { Slot } from "../Slot/Slot";
import styles from "./SingleColumn.module.scss";
import classNames from "classnames/bind";
import useRouteLoading from "../../hooks/useRouteLoading";

const cx = classNames.bind(styles);

export const slotNameMap = {
  HEADER: "header",
  TOP: "top",
  MAIN: "main",
  FOOTER: "footer",
} as const;

export function SingleColumn(props: PageProps) {
  const isRouteLoading = useRouteLoading();

  return (
    <div data-layout="Default" className={styles.page}>
      <Slot {...props} name={slotNameMap["HEADER"]} sizes="100vw" />
      <main className={styles.main}>
        <Slot
          {...props}
          name={slotNameMap["TOP"]}
          sizes="100vw"
          className={styles.top}
        />
        <div className={styles.content}>
          <Slot
            {...props}
            name={slotNameMap["MAIN"]}
            sizes="100vw"
            className={cx("mainSlot", {
              "u-loading": isRouteLoading,
            })}
          />
        </div>
      </main>
      <Slot {...props} name={slotNameMap["FOOTER"]} sizes="100vw" />
    </div>
  );
}
